export const mobilityCategories: any = {
  // ORDER: [{ label: "Ticket not generated", code: "ORD101" }],
  FULFILLMENT: [
    // { label: "Ticket not working", code: "FLM101" },
    { label: "Unable to cancel the ticket", code: "FLM102" },
    { label: "Unable to modify ticket details", code: "FLM103" },
    // { label: "Ticket not working - due to To & fro mismatch", code: "FLM104" },
  ],
  PAYMENT: [
    { label: "Refund not received", code: "PMT101" },
    // { label: "Amount deducted but payment failed", code: "PMT102" },
    // { label: "Overpaid (RSF)", code: "PMT103" },
    { label: "Not paid (RSF)", code: "PMT104" },
    { label: "Partially paid (RSF)", code: "PMT105" },
    { label: "Delayed payment (RSF)", code: "PMT106" },
  ],
};
// https://ondc-preprod.sequelstring.com/seller/dmrc/igm/client/update_issue
export const insuranceCategories: any = {
  CLAIMS: [
    { label: "Claim not processed", code: "CLM101" },
    { label: "Claim denied", code: "CLM102" },
    { label: "Partial claim payment", code: "CLM103" },
    { label: "Delayed claim processing", code: "CLM104" },
  ],
  POLICY: [
    { label: "Unable to update beneficiary", code: "POL101" },
    { label: "Policy renewal issues", code: "POL102" },
    { label: "Incorrect policy details", code: "POL103" },
    { label: "Policy cancellation issues", code: "POL104" },
  ],
  PAYMENT: [
    { label: "Premium refund not received", code: "PMT201" },
    { label: "Overcharged premium", code: "PMT202" },
    { label: "Automatic payment failed", code: "PMT203" },
    { label: "Payment not reflected in policy", code: "PMT204" },
  ],
};
export const personalLoanCategories: any = {
  APPLICATION: [
    { label: "Application not submitted", code: "APP101" },
    { label: "Application pending", code: "APP102" },
    { label: "Application denied", code: "APP103" },
    { label: "Required documents missing", code: "APP104" },
  ],
  DISBURSEMENT: [
    { label: "Disbursement delayed", code: "DIS101" },
    { label: "Disbursement amount incorrect", code: "DIS102" },
    { label: "Disbursement failed", code: "DIS103" },
  ],
  REPAYMENT: [
    { label: "Repayment not reflected", code: "REP101" },
    { label: "Incorrect repayment amount", code: "REP102" },
    { label: "Early repayment penalty", code: "REP103" },
    { label: "Repayment schedule not updated", code: "REP104" },
  ],
  SERVICE: [
    { label: "Customer service not responsive", code: "SER101" },
    { label: "Issue not resolved", code: "SER102" },
    { label: "Feedback not acknowledged", code: "SER103" },
  ],
};
